import { throttle } from 'lodash';
import simpleParallax from 'simple-parallax-js';
import { viewportPercentage } from '@/utilities';

// Hero/Slide images
const images = document.querySelectorAll('.parallax');
new simpleParallax(images, {
    scale: 1.1
});

const translateImage = (elem, min, max, inverse = false) => {
    const translateTo = () => {
        const result = viewportPercentage(elem);
        if (result) {
            const percentage = inverse ? 100 - result : result;
            const value = (percentage / 100) * (max - min) + min;
            elem.style.transform = `translateX(${value}%)`;
        }
    };

    window.addEventListener('scroll', throttle(translateTo, 50), false);
};

const penguin = document.querySelector('#penguin');
const seal = document.querySelector('#seal');

if (penguin) {
    translateImage(penguin, 0, 25);
}

if (seal) {
    translateImage(seal, -25, 0, true);
}
